// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2iOaG","right":"Footer_right__cKtxi","buttons":"Footer_buttons__2R849"};